import { Component, defineComponent } from '@decify/cell-shopify/client';
import './VideoButton.scss';
export const videoButtonName = 'VideoButton';
export const videoButtonTagName = 'cell-component-video-button';
export class VideoButton extends Component {
    constructor() {
        super(videoButtonName);
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.addEventListener('click', this.handleClick);
    }
    handleClick() {
        this.publish('click');
    }
}
defineComponent(videoButtonTagName, VideoButton);
